import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
// @ts-ignore
import { NotificationManager } from 'react-notifications';

import { dispatch } from 'store';
import { Input, Button, LanguagesSelect } from 'views/components';
import { RootState } from 'types';

import { t } from 'utils';
import logo from 'assets/images/logo.svg';
import styles from './ResetPassword.module.css';
import { setUserInfoData, updateUserPassword } from 'modules/user/actions';
import { setNotification } from 'modules/app/actions';
import texts from './texts';

export const ResetPassword: FC = () => {
  const { userInfo, errors, loading } = useSelector((state: RootState) => state.user);
  const { notification } = useSelector((state: RootState) => state.app);

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    dispatch(setUserInfoData(name, value));
  };

  useEffect(() => {
    if (notification.status && notification.type === 'success') {
      NotificationManager.success(notification.text);
      dispatch(setNotification(false));
    }
  }, [notification]);

  const { newPassword, currentPassword, passwordConfirm } = userInfo;

  const disabled = !newPassword || !passwordConfirm || !currentPassword;
  const unconfirmPasword = newPassword && newPassword !== passwordConfirm && passwordConfirm;

  const renderError = () => {
    for (let key in errors) {
      return <p style={{ color: 'red', fontSize: '12px' }}>{errors[key]}</p>;
    }
  };

  return (
    <div className={styles.wrap}>
      <div className={styles.top}>
        <Link to="/dashboard">
          <img className={styles.logo} src={logo} alt="Logo" />
        </Link>
        <LanguagesSelect />
      </div>
      <div>
        <Link className={styles.link} to="/dashboard">
          {t(texts.backToDashboard)}
        </Link>
      </div>
      {renderError()}
      <h1 style={{ fontSize: 40, fontWeight: 'bold', lineHeight: '50px' }}>{t(texts.title)}</h1>
      <Input
        name="currentPassword"
        value={userInfo.currentPassword}
        onChange={(e: any) => handleInputChange(e)}
        label="Current Password"
        type="password"
        maxLength={64}
      />
      <div className={styles.items}>
        <div className={styles.item}>
          <Input
            name="newPassword"
            value={userInfo.newPassword}
            onChange={(e: any) => handleInputChange(e)}
            label="New Password"
            type="password"
            maxLength={64}
          />
        </div>
        <div className={styles.item}>
          <Input
            name="passwordConfirm"
            value={userInfo.passwordConfirm}
            onChange={(e: any) => handleInputChange(e)}
            label="Repeat New Password"
            type="password"
            maxLength={64}
          />
        </div>
      </div>
      {unconfirmPasword && <p style={{ fontSize: '12px', color: 'red' }}>{t(texts.mistmatch)}</p>}
      <div style={{ marginTop: '40px' }}>
        <Button
          disabled={disabled || unconfirmPasword}
          title="Save changes"
          onClick={() => dispatch(updateUserPassword.request())}
          loading={loading}
        />
      </div>
    </div>
  );
};
